import { gql } from '@provision/graphql-client';
import { CLIENT_FIELDS } from './client.fragments';

export const DEFAULT_CLIENTS_QUERY_LIMIT = 10;

export const UPDATE_CLIENT_MUTATION = gql`
  mutation UpdateClient($conditions: [ConditionInput], $data: ClientDataInput) {
    updateClient(conditions: $conditions, data: $data) {
      ...ClientFields
    }
  }
  ${CLIENT_FIELDS}
`;

export const SAVE_CLIENT_WITH_RELATED_DATA_MUTATION = gql`
  mutation SaveClientWithRelatedData(
    $clientId: String
    $partnerId: Int!
    $firstName: String!
    $lastName: String
    $notes: String
    $marketingOptOut: Boolean
    $primaryClientEmailId: String
    $primaryEmail: String
    $primaryClientPhoneNumberId: String
    $primaryPhoneNumber: Float
    $emails: [ClientEmailDataInput]
    $phoneNumbers: [ClientPhoneNumberDataInput]
    $address: AddressDataInput
    $participant: ConversationParticipantDataInput
  ) {
    saveClientWithRelatedData(
      params: {
        partnerId: $partnerId
        client: {
          clientId: $clientId
          firstName: $firstName
          lastName: $lastName
          notes: $notes
          marketingOptOut: $marketingOptOut
          primaryClientEmailId: $primaryClientEmailId
          primaryClientPhoneNumberId: $primaryClientPhoneNumberId
        }
        primaryEmail: { clientEmailId: $primaryClientEmailId, value: $primaryEmail }
        primaryPhoneNumber: {
          clientPhoneNumberId: $primaryClientPhoneNumberId
          value: $primaryPhoneNumber
        }
        emails: $emails
        phoneNumbers: $phoneNumbers
        address: $address
        participant: $participant
      }
    ) {
      client {
        ...ClientFields
      }
    }
  }
  ${CLIENT_FIELDS}
`;

export const MERGE_CLIENT_MUTATION = gql`
  mutation MergeClient($clientOriginId: String!, $clientTargetId: String!) {
    mergeClient(params: { clientOriginId: $clientOriginId, clientTargetId: $clientTargetId }) {
      success
      error
    }
  }
`;

export const DELETE_CLIENT_WITH_RELATED_DATA_MUTATION = gql`
  mutation DeleteClientWithRelatedData($params: DeleteClientWithRelatedDataInput!) {
    deleteClientWithRelatedData(params: $params) {
      clientId
    }
  }
`;

export const RESTORE_DELETED_CLIENT_MUTATION = gql`
  mutation RestoreDeletedClient($params: RestoreDeletedClientInput!) {
    restoreDeletedClient(params: $params) {
      clientId
    }
  }
`;
